import React, { useState, useEffect, useRef } from 'react'
import './styleUserDetails.css'
import INCSUBPersnolDetails from '../../../components/users/PersnolDetails'
import INCSUBWalleteDetails from '../../../components/users/WalleteDetails'
import INCSUBPlatformAndPools from '../../../components/users/PlatformAndPools'
import { useDispatch, useSelector } from 'react-redux'
import { setProfileInfo, setSelectedUser, setUserCountData, setUserList, setUsrDetailsRoute } from '../../../features/users/userSlice'
import { getUserCounts, getUserPersonalDetails, getUserUpdateDetails } from '../../../services/userServices'
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
} from 'react-image-crop'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'

function INCSUBUserDetails() {


  const dispatch = useDispatch();
  const userDetailsRoute = useSelector((state) => state.user.userDetailsRoute);
  const user = useSelector((state) => state.user.selectedUser);
  const [personalDetailData, setPersonalDetailData] = useState(null);
  const [initialData, setInitialData] = useState(null)
  const [statusListIsopen, setStatuslistIsopen] = useState(false)
  const statusListRef = useRef(null)
  const [crop, setCrop] = useState(null);
  const [imgSrc, setImgSrc] = useState(personalDetailData?.userImage);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [aspect] = useState(1 / 1);
  const imgRef = useRef(null);
  const blobUrlRef = useRef('');
  const previewCanvasRef = useRef(null);
  const userCountData = useSelector((state) => state.user.userCountData);
  const [imgBlobFile, setImgBlobFile] = useState('')
  const [cropUrl, setCropUrl] = useState('')
  const navigate = useNavigate();
  const userList = useSelector((state) => state.user.userList)
  const routeStatus = useSelector((state) => state.common.routeStatus);
  const profileInfo = useSelector((state) => state.user.profileInfo)


  const [statusList, setStatusList] = useState([
    { status: 'Active', bg: 'rgba(0, 182, 155, 0.2)', color: 'rgba(0, 182, 155, 1)' },
    { status: 'Suspended', bg: 'rgba(255, 235, 204, 1)', color: 'rgba(255, 157, 0, 1)' },
    { status: 'Inactive', bg: 'rgba(252, 215, 212, 1)', color: 'rgba(239, 56, 38, 1)' },
  ]);

  const [statusValue, setStatusValue] = useState({ status: '', bg: '', color: '' });
  const [selectedStatusList, setSelectedStatusList] = useState([]);

  useEffect(() => {
    if (personalDetailData?.status) {
      const matchedStatus = statusList.find(item => item.status === personalDetailData.status);
      if (matchedStatus) {
        setStatusValue(matchedStatus);
        setSelectedStatusList(statusList.filter(item => item.status !== matchedStatus.status));
      }
    }
  }, [statusValue, personalDetailData?.status]);

  const fetchPersonalDetails = async (userId) => {

    try {

      const response = await getUserPersonalDetails(userId);
      if (response?.request?.status === 200) {
        localStorage.setItem('userPersonalDetails', JSON.stringify(response?.data?.data));
        setPersonalDetailData(response?.data?.data);
        dispatch(setSelectedUser(response?.data?.data))

      } else if (response?.request?.status === 401) {
        navigate('/login');
      } else if (![200, 401].includes(response?.request?.status)) {
        toast.error(response?.request?.data.message)
      }
    } catch (error) {
      toast.error("Something Went Wrong")
    }
  };

  useEffect(() => {
    if (user) {
      fetchPersonalDetails(user?.userId)
    }

  }, [])

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userPersonalDetails"));
    if (storedData) {
      setInitialData(storedData)
    } else {
    }
  }, []);


  /* @Author Vishal
    Created on 2025-02005
    function Name : convertDateFormat
    parameters : 2025-01-09T18:51:36
    output : January 9, 2025
*/
  const convertDateFormat = (date) => {
    const dateStr = date;
    const dateObj = new Date(date);

    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', options);
    return formattedDate;

  }


  const fetchCountData = async () => {
    const response = await getUserCounts();
    if (response?.request?.status === 200) {
      dispatch(setUserCountData(response?.data?.data))

    }
  };
  const fetchPersonalDetailsUpdate = async (obj1, obj2) => {
    const requetsParam = {
      "userId": personalDetailData?.userId,
      "userFullName": null,
      "userEmail": null,
      "userMobileNumber": null,
      "userDob": null,
      "userPassword": null,
      "userRole": null,
      "status": obj1 !== null ? obj1?.status : null,
      "userImageFile": obj2,
    }
    if (requetsParam.userId === profileInfo.userId) {
      toast.warning(`${profileInfo?.userRole} not able to change self status`)
      return
    }
    setStatusValue(obj1)
    const filteredData = Object.entries(requetsParam).filter(([key, value]) => value != null);
    const obj = Object.fromEntries(filteredData);
    const response = await getUserUpdateDetails(obj);
    if (response?.request?.status === 200) {
      if (requetsParam?.status) {
        fetchCountData()
      }
      setPersonalDetailData(prevData => {
        const updatedData = { ...prevData, status: obj1?.status ? obj1?.status : null };
        localStorage.setItem('userPersonalDetails', JSON.stringify(updatedData));
        return updatedData;
      });
      const updatedUserList = userList.map((usr) =>
        usr.userId === user.userId
          ? { ...usr, status: requetsParam.status }
          : usr
      );

      dispatch(setUserList(updatedUserList))
    } else {
      toast.error('Something went wrong')
    }
  };

  useEffect(() => {
    function handleOutsideClick(event) {
      if (statusListRef && statusListRef.current && !statusListRef.current.contains(event.target)) {
        setStatuslistIsopen(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])


  const functionCall = () => {
    const storedData = JSON.parse(localStorage.getItem("userPersonalDetails"))
    setPersonalDetailData(storedData)
  }

  function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(null);
      const reader = new FileReader();
      reader.addEventListener('load', () => setImgSrc(reader.result?.toString() || ''));
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }


  function centerAspectCrop(
    mediaWidth,
    mediaHeight,
    aspect,
  ) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight,
      ),
      mediaWidth,
      mediaHeight,
    )
  }

  const userImageUpdate = async (blob, image) => {
    try {
      const response = await getUserUpdateDetails({ userId: user.userId, userImageFile: blob });

      if (response?.request?.status === 200) {
        const updatedData = {
          ...user,
          userImage:response?.data.data.userImage,
        };
        setPersonalDetailData({
          ...updatedData,
          userImage: response?.data.data.userImage,
          userRole: profileInfo.userRole
        })
        setSelectedUser({
          ...updatedData,
          userImage: response?.data.data.userImage,
          userRole: profileInfo.userRole
        })
        if (user.userId === profileInfo.userId) {
          dispatch(setProfileInfo({
            ...updatedData,
            userImage: response?.data.data.userImage,
            userRole: profileInfo.userRole
          }))
          window.localStorage.setItem("userData", JSON.stringify({
            ...updatedData,
            userImage: response?.data.data.userImage,
            userRole: profileInfo.userRole
          }))
        }

      } else if (response?.request?.status === 401) {
        navigate('/login')
        window.localStorage.setItem('token', "")
      } else {
        toast.error("Something went wrong")
      }
    } catch (err) {
      toast.error("Something went wrong")
    }
  }

  async function onDownloadCropClick() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop?.width || !completedCrop?.height) {
      console.error("Crop canvas does not exist or is incomplete.");
      return;
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // Create an offscreen canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      console.error("No 2D context on canvas.");
      return;
    }

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    // Convert canvas to Blob
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error("Failed to create Blob from canvas.");
        return;
      }

      // Generate a URL for the Blob
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
      blobUrlRef.current = URL.createObjectURL(blob);

      // Convert canvas to Data URL
      const croppedImageUrl = canvas.toDataURL('image/png');
      userImageUpdate(blob, croppedImageUrl)
      setImgBlobFile(blob)
      setCropUrl(croppedImageUrl);



      localStorage?.setItem('userPersonalDetails', personalDetailData)
    }, 'image/png');
  }

  return (
    <div className='UNCSUBuser_details'>
      <div className='INCSUBuser_details_container'>
        <div className='INCSUBuser_sidebar_container'>
          <div className='INCSUBuser_profile_info_container'>
            <div className='INCSUBuser_profile_image'
              style={{
                backgroundImage: `url(${personalDetailData?.userImage ? personalDetailData?.userImage : `/assets/icons/common/defaultImage.png`})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: '1px solid grey'
              }}>
              <input className='INCSUBProfileUpload' type="file" accept="image/*" onChange={onSelectFile} />
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.75 42C32.9338 42 42 32.9338 42 21.75C42 10.5662 32.9338 1.5 21.75 1.5C10.5662 1.5 1.5 10.5662 1.5 21.75C1.5 32.9338 10.5662 42 21.75 42Z" fill="#4880FF" stroke="white" stroke-width="3" />
                <path d="M13.75 29.75V25.9722L25.4833 14.2611C25.6611 14.0981 25.8576 13.9722 26.0727 13.8833C26.2878 13.7944 26.5136 13.75 26.75 13.75C26.9864 13.75 27.2161 13.7944 27.4389 13.8833C27.6617 13.9722 27.8543 14.1056 28.0167 14.2833L29.2389 15.5278C29.4167 15.6907 29.5464 15.8833 29.6282 16.1056C29.71 16.3278 29.7506 16.55 29.75 16.7722C29.75 17.0093 29.7094 17.2353 29.6282 17.4504C29.547 17.6656 29.4173 17.8617 29.2389 18.0389L17.5278 29.75H13.75ZM26.7278 18.0167L27.9722 16.7722L26.7278 15.5278L25.4833 16.7722L26.7278 18.0167Z" fill="white" />
              </svg>
            </div>
            <div className='INCSUBuser_profile_overview_details'>
              <div className='INCSUBuser_profile_name_info'>
                <div className='INCSUBuser_profile_name'>{personalDetailData?.userFullName}</div>
                <div className='INCSUBuser_profile_type'>{personalDetailData?.userRole}</div>{console.log(personalDetailData)}
              </div>
              <div className='INCSUBuser_joining_date'>{convertDateFormat(personalDetailData?.createdAt)}</div>
              <div className='INCSUBuser_profile_status_container' onClick={() => { setStatuslistIsopen(true) }} style={{ background: `${statusValue?.bg}`, color: `${statusValue?.color}`, cursor: 'pointer' }}>
                <div className='INCSUBuser_profile_status_name'>{statusValue?.status}</div>
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 1L5 5L1 1" stroke={`${statusValue?.color}`} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {statusListIsopen &&
                  <div className='INCSUBStatusList' ref={statusListRef}>
                    {selectedStatusList && selectedStatusList?.map((obj, index) => (
                      <div className='INCSUBStatusHolderDiv' style={{ borderTop: index !== 0 ? ' 0.6px solid rgba(151, 151, 151, 1)' : 'none' }}>
                        <div style={{ backgroundColor: obj.bg, color: obj.color, cursor: 'pointer' }} className='INCSUBStatus' onClick={() => {
                          fetchPersonalDetailsUpdate(obj, null)
                        }}>{obj?.status}</div>
                      </div>
                    ))}
                  </div>
                }
              </div>

            </div>
          </div>
          <div className='INCSUBuser_profile_section_tabs_container'>
            <div className='INCSUBuser_profile_section_tabs personal_details' style={{ cursor: 'pointer', color: userDetailsRoute === "/personaldetails" ? "#4880FF" : null }} onClick={() => dispatch(setUsrDetailsRoute("/personaldetails"))}>
              <div className='INCSUBuser_profile_tab_name'>
                Personal Details
              </div><svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 13.5L7 7.5L1 1.5" stroke={userDetailsRoute === "/personaldetails" ? "#4880FF" : "rgba(32, 34, 36, 0.6) "} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            {routeStatus !== '/userPersonalDetails' ? <div className='INCSUBuser_profile_section_tabs wallet_details' style={{ cursor: 'pointer', color: userDetailsRoute === "/walletdetails" ? "#4880FF" : null }} onClick={() => dispatch(setUsrDetailsRoute("/walletdetails"))}>
              <div className='INCSUBuser_profile_tab_name'>
                Wallet Details
              </div><svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 13.5L7 7.5L1 1.5" stroke={userDetailsRoute === "/walletdetails" ? "#4880FF" : "rgba(32, 34, 36, 0.6) "} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div> : null}
            {routeStatus !== "/platformandpools" ? <div className='INCSUBuser_profile_section_tabs platforms_pools' style={{ cursor: 'pointer', color: userDetailsRoute === "/platformandpools" ? "#4880FF" : null }} onClick={() => dispatch(setUsrDetailsRoute("/platformandpools"))}>
              <div className='INCSUBuser_profile_tab_name'>
                Platforms & Pools
              </div><svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 13.5L7 7.5L1 1.5" stroke={userDetailsRoute === "/platformandpools" ? "#4880FF" : "rgba(32, 34, 36, 0.6)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div> : null}
          </div>
        </div>
        <div className='INCSUBusr_profile_detail_view_container'>{
          userDetailsRoute === '/personaldetails' ? <INCSUBPersnolDetails personalDetailData={personalDetailData} functionCall={functionCall} /> : null
        }
          {
            userDetailsRoute === '/walletdetails' ? <INCSUBWalleteDetails personalDetailData={personalDetailData} /> : null
          }
          {
            userDetailsRoute === '/platformandpools' ? <INCSUBPlatformAndPools personalDetailData={personalDetailData} /> : null
          }

        </div>
      </div>
      {
        imgSrc && (
          <div className="crop_image_holder_absolute">
            <div className='crop_image_holder'>
              <div className='image_container'>
                <ReactCrop
                  crop={crop}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  onComplete={(c) => setCompletedCrop(c)}
                  aspect={aspect}
                >
                  <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
                </ReactCrop>
              </div>
              <div className="image_upload_btn">
                <button className='upload_btn' disabled={''} onClick={() => {
                  onDownloadCropClick();
                  setImgSrc(null)
                }}>Upload</button>
                <button className='upload_cancel_btn' disabled={''} onClick={() => setImgSrc(null)}>Cancel</button>
              </div>
            </div>
          </div>
        )
      }

      {/* Hidden Canvas for Cropping */}
      <canvas ref={previewCanvasRef} style={{ display: 'none' }} />
    </div >
  )
}

export default INCSUBUserDetails
